import type * as React from 'react';

function SvgCircleTick(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" height="1em" viewBox="0 0 16 16" width="1em" {...props}>
      <path
        d="M7.99967 1.33337C4.32387 1.33337 1.33301 4.32391 1.33301 8.00004C1.33301 11.6762 4.32387 14.6667 7.99967 14.6667C11.6755 14.6667 14.6663 11.6762 14.6663 8.00004C14.6663 4.32391 11.6755 1.33337 7.99967 1.33337ZM7.99967 13.3334C5.05894 13.3334 2.66634 10.9408 2.66634 8.00004C2.66634 5.05931 5.05894 2.66671 7.99967 2.66671C10.9404 2.66671 13.333 5.05931 13.333 8.00004C13.333 10.9408 10.9404 13.3334 7.99967 13.3334Z"
        fill="currentColor"
      />
      <path
        d="M10.6464 5.64648L6.99994 9.29294L5.35348 7.64648C5.15814 7.45114 4.84174 7.45114 4.64648 7.64648C4.45121 7.84181 4.45114 8.15821 4.64648 8.35348L6.64648 10.3535C6.74414 10.4511 6.87174 10.4999 7.00001 10.4999C7.12828 10.4999 7.25588 10.4511 7.35354 10.3535L7.68688 10.0201L11.3535 6.35348C11.5489 6.15814 11.5489 5.84174 11.3535 5.64648C11.1582 5.45121 10.8417 5.45114 10.6464 5.64648Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgCircleTick;
